import { useDocumentListSearchParams } from "../../useDocumentListSearchParams"
import type { Filter, FilterType } from "./FilterDropdown"

export function useActionBar() {
  const { optimisticSearchParams, searchAction } = useDocumentListSearchParams()

  const selectedCustomTypeFilters = getFilters(
    optimisticSearchParams.customTypes,
    "customType",
  )
  const selectedTagFilters = getFilters(optimisticSearchParams.tags, "tag")
  const selectedAuthorFilters = getFilters(
    optimisticSearchParams.authors,
    "author",
  )
  const selectedFilters = [
    ...selectedCustomTypeFilters,
    ...selectedAuthorFilters,
    ...selectedTagFilters,
  ]

  function toggleFilter(filter: Filter) {
    const { type, value } = filter

    if (type === "status") return
    searchAction.toggleArrayValue(`${type}s`, value)
  }

  function removeFilter(filter: Filter) {
    const { type, value } = filter

    if (type === "status") return
    searchAction.removeArrayValue(`${type}s`, value)
  }

  return {
    selectedCustomTypeFilters,
    selectedAuthorFilters,
    selectedTagFilters,
    selectedFilters,
    toggleFilter,
    removeFilter,
    searchAction,
  }
}

function getFilters(options: string[] = [], type: FilterType) {
  return options.map((option) => ({
    type,
    value: option,
  }))
}
